import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalComponent } from '../components/modal/modal.component';
import { DynamicHostModel } from '../models/dynamic-host.model';

@Injectable({
    providedIn: 'root'
})
export class NRModalService {
    modalRef: BsModalRef;

    constructor(private modalService: BsModalService) { }

    open(options: DynamicHostModel, size: string = 'lg'): void {
        const initialState  = {
            dynamicModel: options
        };

        this.modalRef = this.modalService.show(ModalComponent, {initialState});
        console.log(size)
        this.modalRef.setClass(`modal-${size}`);
    }
}
